// BrandMarquee.js
import React from "react";
import { Container } from "react-bootstrap";
import Marquee from "react-fast-marquee";
import { brandLogosContent } from "../../../../Constants/content";




const BrandMarquee = () => {
  return (
    <div style={{ background: "#fff", padding: "60px 0" }}>
      <Container>
        <h2 className="text-center fw-bold mb-5" style={{ color: "#009fe3" }}>
          Trusted by Top Brands
        </h2>

        {brandLogosContent.map((row, index) => (
          <Marquee
            key={index}
            direction={index % 2 === 0 ? "left" : "right"}
            gradient={false}
            speed={25} // Slower speed
            pauseOnHover
            className="mb-4"
          >
            {row.map((logo, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "120px",
                  height: "50px",
                  marginRight: "40px"
                }}
              >
                <img
                  src={logo.url}
                  alt={logo.name}
                  style={{
                    maxHeight: "40px",
                    maxWidth: "100%",
                    objectFit: "contain",
                    filter: "grayscale(0%)",
                  }}
                />
              </div>
            ))}
          </Marquee>
        ))}
      </Container>
    </div>
  );
};

export default BrandMarquee;
